export const transactionTypeOptions = [
  { id: 1, value: 'PIX', label: 'PIX' },
  { id: 2, value: 'TED', label: 'TED' },
]

export const pixKeyOptions = [
  { id: 1, value: 'CPF', label: 'CPF' },
  { id: 2, value: 'CNPJ', label: 'CNPJ' },
  { id: 3, value: 'E-mail', label: 'E-mail' },
  { id: 4, value: 'Número de telefone', label: 'Telefone' },
  { id: 5, value: 'Chave aleatória', label: 'Chave Aleatória' },
]
